import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  HostBinding,
  input,
  Input,
  Output
} from '@angular/core';
import { ShirtCategory, TShirtCategory } from '@ag-common-lib/lib/models/utils/t-shirt-sizes.model';
import { ActiveLookup, LookupId, LookupKeys, Messages } from '@ag-common-lib/public-api';
import { LookupsService } from 'ag-common-svc/lib/services';
import { Observable, of } from 'rxjs';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { toObservable } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs/operators';
import { getShirtCategoryFromSize } from 'ag-common-svc/lib/utils/t-shirt-size.utils';

@Component({
  selector: 'ag-shr-t-shirt-size-dropdown',
  templateUrl: './t-shirt-size-dropdown.component.html',
  styleUrl: './t-shirt-size-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TShirtSizeDropdownComponent {
  @HostBinding('class') className = 't-shirt-size-dropdown';

  @Input() value: LookupId<any> | null = null;
  @Output() valueChange = new EventEmitter<LookupId<any> | null>();
  @Output() selectedItemChange = new EventEmitter<ActiveLookup | null>();

  @Input() name?: string;
  @Input() label = 'Size';
  @Input() placeholder = '';
  @Input() labelMode: 'static' | 'floating' | 'hidden' = 'floating';
  @Input() validationGroup?: string;

  categorySig = input<TShirtCategory | ShirtCategory>(null, { alias: 'category' });
  disabledSig = input(false, { alias: 'disabled' });
  readOnlySig = input(false, { alias: 'readOnly' });
  isRequiredSig = input(false, { alias: 'isRequired' });

  protected readonly LookupKeys = LookupKeys;
  protected readonly requiredText = Messages.REQUIRED_TEXT;
  protected readonly BaseModelKeys = BaseModelKeys;

  constructor(private readonly lookupsService: LookupsService) {}

  protected readonly dataSource$: Observable<ActiveLookup[]> = toObservable(this.categorySig).pipe(
    switchMap(category => {
      const currentCategory = category || getShirtCategoryFromSize(this.value as string);

      switch (currentCategory) {
        case TShirtCategory.adult:
          return this.lookupsService.tShirtAdultLookup$;

        case TShirtCategory.youth:
          return this.lookupsService.tShirtYouthLookup$;

        case ShirtCategory.men:
          return this.lookupsService.shirtMenLookup$;

        case ShirtCategory.women:
          return this.lookupsService.shirtWomenLookup$;

        default:
          return of([]);
      }
    }),
  );
}
